import { Icons, defaultTheme } from '@agro-club/agroclub-shared'
import { Deal, DealStatusTypes } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { AButton } from 'views/components/Analytics'
import AMobileButton from 'views/components/Analytics/AMobileButton'
import { CloseDealModal } from 'views/components/CloseDealModal/CloseDealModal'

export const CloseDeal: FC<{ deal: Deal }> = ({ deal }) => {
  const { t } = useTranslation('deal')
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })
  return (
    <>
      {isMobile ? (
        <AMobileButton
          disabled={deal.status === DealStatusTypes.DRAFT}
          onClick={() => setIsOpen(true)}
          Icon={Icons.IconClose}
          color="destruct"
          id="close"
        >
          {t('closeDeal')}
        </AMobileButton>
      ) : (
        <AButton
          disabled={deal.status === DealStatusTypes.DRAFT}
          onClick={() => setIsOpen(true)}
          color="destruct"
          size="medium"
          id="close"
        >
          {t('closeDeal')}
        </AButton>
      )}

      {isOpen && <CloseDealModal onClose={() => setIsOpen(false)} />}
    </>
  )
}
